import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// Plugins
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import '@/plugins/validations'

// 3rd Party Packages
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import VuejsDialog from 'vuejs-dialog'
import VuePlyr from 'vue-plyr'

// Mixins
import locale from './mixins/locale'

// Others
import 'es6-promise/auto'

// CSS
import '@fortawesome/fontawesome-free/css/all.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css'
import 'nprogress/nprogress.css'
import '@/css/app.css'

// Plugins Registration
Vue.prototype.$API_URL = window.API_URL
Vue.use(VuejsDialog)
Vue.use(VuePlyr)
Vue.config.productionTip = false
Vue.config.performance = true

// Component Registration
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

// Mixins Registrations
Vue.mixin(locale)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
})
